import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
} from "@/frontend/algolia/components/ui/carousel";
import ProductCard from "../../../components/ProductCard";
import { CuratedProduct } from "../types";

interface CuratedPicksProps {
  title: string;
  products: CuratedProduct[];
  carouselOptions?: {
    loop?: boolean;
    align?: "start" | "center" | "end";
  };
}

export default function CuratedPicks({
  products,
  title,
  carouselOptions = { loop: true, align: "start" },
}: CuratedPicksProps) {
  if (!products.length) {
    return null;
  }

  return (
    <div>
      <Carousel opts={carouselOptions} className="tw-w-full">
        <div className="tw-flex tw-flex-row tw-justify-between">
          <h2 className="tw-text-xl">{title}</h2>

          <CarouselNext />
        </div>

        <CarouselContent className="tw--ml-1">
          {products.map((product, index) => (
            <CarouselItem
              key={index}
              className="tw-basis-2/3 md:tw-basis-1/2 lg:tw-basis-1/3 xl:tw-basis-1/4"
            >
              <ProductCard
                title={product.title}
                description={product.description}
                imageSrc={product.imageSrc}
                link={product.link}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
}